"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseViewModel_1 = require("./base/baseViewModel");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.defaultFilters = this.options.defaultFilters;
        $(document).off("submit", "#author-search-form");
        $(document).on("submit", "#author-search-form", function (event) {
            var $form = $(event.currentTarget);
            var elemetsToDelete = [];
            $form.serializeArray().forEach(function (element, index, array) {
                var defaultValue = _this.defaultFilters.find(function (x) { return x.Key === element.name; });
                if (element.value === "" || defaultValue && defaultValue.Value === element.value) {
                    elemetsToDelete.push(element.name);
                }
            });
            elemetsToDelete.forEach(function (element, index, array) {
                $form.find("[name=\"" + element + "\"]").remove();
            });
        });
    }
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=searchAuthors.js.map